import { StrictMode } from 'react';
import ReactDom from 'react-dom';
import { version as bifrostVersion } from '../../../../package.json';
import { version as stvHostVersion } from '../package.json';
import { App } from './App';

ReactDom.render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.querySelector('#container-root'),
);

console.log(`stv-host=${stvHostVersion}; bifrost=${bifrostVersion}`);
